import React from "react";
import { Link } from "react-router-dom";

import { ReactComponent as AlarmIcon } from "static/icons/alarm.svg";
import { ReactComponent as SearchIcon } from "static/icons/search.svg";
import Container from "components/Common/Container";
import { browserRoutes } from "constants/routes";
import { useFeatureFlags } from "constants/index";
import MyProfileAvatar from "components/Pictures/MyProfileAvatar";
import styles from "./Header.module.scss";
import { ReactComponent as LogoIcon } from "static/icons/logo_portal.svg";
import { ReactComponent as WartsilaLogo } from "static/icons/wartsila_logo.svg";
import { Breakpoint } from "types/breakpoint";
import useBreakPoint from "../../../hooks/useBreakPoint";
import HamburgerMenu from "components/Nav/Navigation/HamburgerMenu";
import classNames from "classnames";
import Button from "components/Buttons/Button";

const SearchBar = () => {
    return (
        <div className={styles["search-bar"]}>
            <SearchIcon className={styles["search-bar__icon"]} />
            <input
                className={styles["search-bar__input"]}
                type="search"
                name="query"
                placeholder="Search..."
            />
        </div>
    );
};

const Header = () => {
    const featureFlags = useFeatureFlags();
    const isMobile = useBreakPoint(Breakpoint.mobile);
    const [isOpen, setIsOpen] = React.useState(false);
    const classes = classNames(
        styles["hamburger-menu"],
        {
            [styles["hamburger-menu--open"]]: isOpen,
            [styles["hamburger-menu--close"]]: !isOpen,
        },
        styles["header__hamburger-menu"],
    );

    const searchBar = isMobile ? (
        <SearchIcon className={styles["header__search-icon"]} />
    ) : (
        <SearchBar />
    );

    return (
        <header className={styles["header"]}>
            <Container contained={false} className={styles["header__content-container"]}>
                <Link className={styles["header__logo"]} to={`/${browserRoutes.home}`}>
                    <LogoIcon />
                </Link>
                <div className={styles["header--right"]}>
                    {featureFlags.globalSearch && <>{searchBar}</>}
                    {featureFlags.notification && (
                        <AlarmIcon className={styles["header__alarm-icon"]} />
                    )}
                    <Button
                        className={classNames(
                            styles["header__profile-link__button"],
                            styles["button-as-link"],
                        )}
                        size="extra-small"
                        onClick={() => setIsOpen(false)}
                    >
                        <Link
                            className={styles["header__profile-link"]}
                            to={`/${browserRoutes.profile}`}
                        >
                            <MyProfileAvatar className={styles["header__profile-avatar"]} />
                        </Link>
                    </Button>
                    <WartsilaLogo className={styles["header__logo--right"]} />
                    {isMobile && (
                        <HamburgerMenu className={classes} setIsOpen={setIsOpen} isOpen={isOpen} />
                    )}
                </div>
            </Container>
        </header>
    );
};

export default Header;
